import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as types from '../../../constants/actionTypes';
import PharmacyHeader from '../PharmacyHeader';
import SectionLoading from '../../common/SectionLoading';
import SectionLoadingError from '../../common/SectionLoadingError';
import PrescriptionInfo from './PrescriptionInfo';
import PrescriptionStatus from './PrescriptionStatus';
import Prescriber from './Prescriber';
import PickupLocation from '../PickupLocation';
import PrescriptionLastActivity from './PrescriptionLastActivity';
import * as d from "../../../reducers/domainReducer";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

class PrescriptionDetail extends React.Component {
    constructor(props) {
        super(props);
        this.loadData = this.loadData.bind(this);
        this.state = { dataLoaded: false };
    }

    componentWillMount() {
        this.setState({ dataLoaded: false });
    }

    componentDidMount() {
        this.loadData();
        logUI("MBHWeb.UI.Rx.PrescriptionDetail.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.loadData();
    }

    loadData() {
        const { hasPharmacyLogin, currentPharmacyUser, rxNumber, storeNumber, getRxDetail, waitingOnRxDetail, rxDetailLoaded, rxDetailError, isLoggedIn, userDetails, isExternalRx } = this.props;

        if (!this.state.dataLoaded && (hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId)) && isLoggedIn && rxNumber && storeNumber && !waitingOnRxDetail && !rxDetailError && rxDetailLoaded !== rxNumber + storeNumber) {
            this.setState({ dataLoaded: true });
            const query = { rxNumber: rxNumber, storeNumber: storeNumber, isExternalRx: isExternalRx };
            getRxDetail(query, userDetails);
        }
    }

    render() {
        const { rx, waitingOnRxDetail, rxDetailError, rxHistory, waitingOnRxHistory, rxHistoryError, archiveUnarchive, rxArchivingOrUnarchiving, userDetails } = this.props;
        return (
            <div className="container-fluid body-content rx-details-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <PharmacyHeader />
                            {waitingOnRxDetail === true || rxArchivingOrUnarchiving === true
                                ? <div className="col-12"><SectionLoading /></div>
                                : rxDetailError
                                    ? <SectionLoadingError message={rxDetailError.status === 404 ?
                                        "Prescription doesn't exist." : "We're not able to display prescription detail. Please try again later."}
                                      />
                                    : rx &&
                                    <div className="col-12">
                                        <div className="row">
                                            <PrescriptionInfo containerClass="col-12" rx={rx} archiveUnarchive={archiveUnarchive} userDetails={userDetails} />
                                            <PrescriptionStatus containerClass="rx-status-info" rx={rx} />
                                            <div className="col-12 rx-instructions list-item-col not-linked">
                                                <h4 className="h5">Instructions:</h4>
                                                {rx && rx.RxSig ? rx.RxSig : '-'}
                                            </div>
                                            <div className="col-12">
                                                <div className="row">
                                                    <Prescriber containerClass="col-12 col-sm-6 rx-prescriber" prescriberName={rx.PrescriberName} contactNumber={rx.PrescriberContactNumber} />
                                                    <PickupLocation containerClass="col-12 col-sm-6 rx-loc" pharmacy={rx.Pharmacy} />
                                                </div>
                                            </div>
                                            {/* <PrescriptionLastActivity rxHistory={rxHistory} waitingOnRxHistory={waitingOnRxHistory} rxHistoryError={rxHistoryError} containerClass="col-12" />
                                             <div className="col-12 rx-footnote">
                                                <span className="icon-info" /> You can visit your pharmacy to request a print out for all medications.  **standard restrictions apply**
                                            </div> */}
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        rxNumber: ownProps && ownProps.match ? ownProps.match.params.rxNumber : "",
        storeNumber: ownProps && ownProps.match ? ownProps.match.params.storeNumber : "",
        isExternalRx: ownProps && ownProps.match ? ownProps.match.params.isExternalRx : "",
        rx: state.pharmacy.rxDetail,
        waitingOnRxDetail: state.pharmacy.waitingOnRxDetail,
        rxArchivingOrUnarchiving: state.pharmacy.rxArchivingOrUnarchiving,
        rxDetailError: state.pharmacy.rxDetailError,
        rxHistory: state.pharmacy.rxHistory,
        rxHistoryError: state.pharmacy.rxHistoryError,
        waitingOnHistory: state.pharmacy.waitingOnRxHistory,
        rxDetailLoaded: state.pharmacy.rxDetailLoaded,
        isLoggedIn: state.sso.isLoggedIn,
        userDetails: state.sso.userDetails,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRxDetail: (query, userDetails) => {
            dispatch({ type: types.RX_DETAIL, ...query, userDetails: userDetails });
        },
        archiveUnarchive: (rx, userDetails) => {
            dispatch({
                type: types.ARCHIVE_UNARCHIVE_RX_START,
                payload: { rxNumber: rx.RxNumber, storeNumber: rx.StoreNumber, archive: !rx.IsArchived, proxyId: '', userDetails: userDetails }
            });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrescriptionDetail));